function bm_modal(modalClass){
		//if cookie hasn't been set...
	if (document.cookie.indexOf("ModalShown=true")<0) {
		jQuery("." + modalClass).modal("show");
		//Modal has been shown, now set a cookie so it never comes back
		jQuery(".my" + modalClass + "Close").click(function () {
			jQuery("." + modalClass).modal("hide");
		});
		document.cookie = "ModalShown=true; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/";
	}
}

function bm_modal_display(modalClass) {
	setTimeout( bm_modal(modalClass), '1000');
}

//jQuery(document).ready(bm_modal_display("bm-Modal"));
